module.exports = __webpack_public_path__ + "assets/img/btn-detail-1fe5bb73.png";